export const enTranslation = {
  common: {
    loading: 'Loading...',
    error: 'Error occurred',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    noData: 'No data available',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
  },
  dashboard: {
    title: 'Dashboard',
    stats: 'Statistics',
    totalProducts: 'Total Products',
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    activeCustomers: 'Active Customers',
    recentOrders: 'Recent Orders',
    topProducts: 'Top Products',
  },
  products: {
    title: 'Products',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    productName: 'Product Name',
    productNameAr: 'Arabic Name',
    productNameEn: 'English Name',
    price: 'Price',
    description: 'Description',
    descriptionAr: 'Arabic Description',
    descriptionEn: 'English Description',
    category: 'Category',
    stock: 'Stock',
    sku: 'SKU',
    images: 'Images',
    deleteConfirm: 'Are you sure you want to delete this product?',
    addSuccess: 'Product added successfully',
    updateSuccess: 'Product updated successfully',
    deleteSuccess: 'Product deleted successfully',
  },
  orders: {
    title: 'Orders',
    orderId: 'Order ID',
    customer: 'Customer',
    date: 'Date',
    status: 'Status',
    total: 'Total',
    items: 'Items',
  },
  api: {
    networkError: 'Network connection error',
    serverError: 'Server error',
    unauthorized: 'Unauthorized access',
    notFound: 'Not found',
    validationError: 'Validation error',
    success: 'Operation successful',
  },
  currency: {
    egp: 'EGP',
    usd: 'USD',
  },
  direction: 'ltr',
};

export default enTranslation;